import React from 'react';
import { withToast as _withToast } from '@zillow/constellation';

type ToastOptions = {
  duration: number;
};
export interface WithToastProps {
  enqueueToast: (toast: JSX.Element, options?: ToastOptions) => void;
}

export function withToast<P extends WithToastProps>(
  Component: React.ComponentType<P>
) {
  const OriginalToast = _withToast(Component);
  const ComponentWithToast = React.forwardRef(
    (props: Omit<P, 'enqueueToast'>, ref?: React.Ref<unknown>) => (
      <OriginalToast {...props} ref={ref} />
    )
  );
  const displayName = Component.displayName || Component.name || 'Component';
  ComponentWithToast.displayName = `WithToast${displayName}`;
  return ComponentWithToast;
}
